import { zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

/** Coordenada obrigatória: aceita número ou texto numérico e grava como texto, como a coluna. */
export const coordenada = (limite: number) =>
    z
        .union([z.number(), z.string().trim().min(1, 'Obrigatório')])
        .pipe(z.coerce.number().min(-limite).max(limite))
        .transform(String)

export const createLocalSchema = z.object({
    nomeLocal: z.string().min(1, 'Obrigatório'),
    latitude: coordenada(90),
    longitude: coordenada(180),
    endereco: z.string().min(1, 'Obrigatório'),
    cercaEletronica: z
        .string()
        .refine(
            value => !isNaN(Number(value)) && Number(value) > 0,
            'Deve ser um número',
        ),
})

export const updateLocalSchema = createLocalSchema.extend({
    id: z.number(),
    empresaId: z.number(),
    FuncionarioLocais: z.array(zod.FuncionarioLocaisSchema).nullish(),
})

export type Local = z.infer<typeof updateLocalSchema>

const funcionarioLocaisSchema = zod.FuncionarioLocaisSchema.omit({
    __typename: true,
    createdAt: true,
})

export type FuncionarioLocais = z.infer<typeof funcionarioLocaisSchema>

export interface Coordenadas {
    latitude: number
    longitude: number
}
export type Endereco = Coordenadas & {
    endereco: string
}

const service = new ApiService<Local>('locais')
const funcionarios = new ApiService<FuncionarioLocais>('locais-funcionarios')
const endereco = new ApiService<Endereco, Endereco, Coordenadas>(
    'locais/endereco',
)
const coordenadas = new ApiService<
    Coordenadas,
    Coordenadas,
    { endereco: string }
>('locais/coordenadas')

export interface SugestaoEndereco {
    descricao: string
}

const sugestoes = new ApiService<
    SugestaoEndereco,
    SugestaoEndereco,
    { busca: string }
>('locais/sugestoes')

const all = new ApiService<Local>('locais/all')

export const local = Object.assign(service, {
    funcionarios,
    endereco,
    coordenadas,
    sugestoes,
    all,
})
